import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import SocialProof from './components/SocialProof';
import CTA from './components/CTA';
import Footer from './components/Footer';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LegalDisclaimer from './pages/LegalDisclaimer';
// import Blog from './pages/Blog';
// import BlogPost from './pages/BlogPost';
import { SiteWideStructuredData } from './components/SiteWideStructuredData';

function App() {
  return (
    <Router>
      <div className="App">
        <SiteWideStructuredData />
        <Routes>
          <Route path="/terms" element={<><Navbar /><TermsOfService /><Footer /></>} />
          <Route path="/privacy" element={<><Navbar /><PrivacyPolicy /><Footer /></>} />
          <Route path="/legal" element={<><Navbar /><LegalDisclaimer /><Footer /></>} />
          {/* <Route path="/blog" element={<><Navbar /><Blog /><Footer /></>} />
          <Route path="/blog/:slug" element={<><Navbar /><BlogPost /><Footer /></>} />
          <Route path="/developers" element={<><Navbar /><ForDevelopers /><Footer /></>} />
          <Route path="/resources" element={<><Navbar /><Resources /><Footer /></>} /> */}
          <Route path="/" element={
            <>
              <Navbar />
              <Hero />
              <Features />
              <SocialProof />
              <CTA />
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
